export const LIST_GOOGLE_REVIEWS = /* GraphQL */`
  query ListGoogleReviewsQuery {
    listGoogleReviews {
      pk
      sk
      author_name
      author_url
      profile_photo_url
      rating
      relative_time_description
      text
      time
      translated
    }
  }
`;